import { createBrowserHistory } from "history";

// Shared history instance for programmatic navigation outside React components (e.g., sagas)
export const history = createBrowserHistory();
